<ng-container *ngFor="let day of days">
    <p-tag [value]="day" dayBGColor [day]="day"></p-tag>
</ng-container>